import { defaultApiState } from '@/store/types/general.types';
import { FHIRState } from './types/fhir.types';

export const fhirState: FHIRState = {
  apiState: {
    getDefaultParameters: defaultApiState,
    updateDefaultParameter: defaultApiState,
    updateDefaultParameterListValues: defaultApiState,
    getDefaultDownloadPermissions: defaultApiState,
    updateDownloadSettings: defaultApiState,
    getFhirClients: defaultApiState,
    getFhirClientById: defaultApiState,
    createFhirClient: defaultApiState,
    updateFhirClient: defaultApiState,
    deleteFhirClient: defaultApiState,
    updateClientParameters: defaultApiState,
    updateClientDownload: defaultApiState
  },
  defaultParameters: undefined,
  downloadSettings: undefined,
  fhirClients: undefined,
  fhirClient: undefined
};
